/** @jsx jsx */
import { jsx } from '@emotion/core'
import styled from '@emotion/styled/macro'
import React from 'react'
import tw from 'twin.macro'

const PageLayout = styled.main`
  ${tw`relative antialiased`};
`

export default PageLayout
